// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a95845ec","78":"0d9803ab","227":"dc1cff49","463":"51fc0812","488":"29b71886","735":"5353191f","954":"81d45c80"}[chunkId] + ".chunk.js";
};